export default __webpack_public_path__ + "static/media/studio.526637ec.webp";